import React, { useMemo, useState, useRef, useCallback, useEffect } from "react";
import { Table } from "../Vehicles/Vehicle_list/_components/Table";
import { useNavigate, useLocation } from "react-router-dom";
import { MoveLeft, ChevronDown, EllipsisVertical } from "lucide-react";
import issue from "../../assets/svg/issue.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { Button } from "react-bootstrap";
import tata from "../../assets/Vehicles/tata.png";
import pdf from "../../assets/svg/pdf.svg";
import download from "../../assets/svg/download.svg";
import vendor from "../../assets/svg/vendor.svg";
import { getIssueViewDetailsApi } from "./issue-api.js";
import attachment from "../../assets/png/attachment.png";
import StatusUpdateModal from "../Services/Service/status-update.js";
import StatusIssueUpdateModal from "./StatusIssueScreen.jsx";
import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";
import { useGlobal } from "../../GlobalContext.js";

export function ViewIssue() {
  const { rolePermissionList, userType } = useGlobal();

  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};

  const [showStatusUpdate, setShowStatusUpdate] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  useEffect(() => {
    if (id != null && id !== undefined) {
      getIssueViewDetails(id);
    }
  }, [id]);

  const [issueDetails, setIssueDetails] = useState({});
  const getIssueViewDetails = async (id) => {
    try {
      const response = await getIssueViewDetailsApi(id);

      if (response.data.success === true) {
        const issueDetail = response.data.issue ?? {};
        setIssueDetails(issueDetail);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const details = [
    {
      label: "Vendor",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={vendor} alt="vendor" />
          <span>{issueDetails.vendor_name ?? ""}</span>
        </div>
      ),
    },
    {
      label: "Description",
      value: issueDetails.issue_description ?? "",
    },
    {
      label: "Status",
      value: (
        <span className="border-0  py-1 px-4 rounded-pill fs-14 fw-400" style={{ backgroundColor: "#FFEFEF", color: "#172B4D" }}>
          {issueDetails.issue_status ?? ""}
        </span>
      ),
    },
  ];
  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };
  function onSuccessStatusUpdate() {
    setShowStatusUpdate(false);
    setSnackbarMessage("Status updated successfully!");
    setSnackbarStatus(true);
    handleSnackbarShow();
    getIssueViewDetails(id);
  }
  const columns = [
    {
      header: "Workorder ID",
      accessorKey: "work_order_id",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Title",
      accessorKey: "title",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Date",
      accessorKey: "date",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
  ];

  const table = useReactTable({
    data: issueDetails.work_orders ?? [],
    columns,

    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  return (
    <>
      {showStatusUpdate && (
        <StatusIssueUpdateModal
          serviceDetail={issueDetails}
          success={onSuccessStatusUpdate}
          onHide={() => {
            setShowStatusUpdate(false);
          }}
        />
      )}
      <div className="w-100 bg-half-white">
        <div className="d-flex flex-wrap justify-content-between align-items-center bg-white p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className="border p-2 rounded-circle cursor-pointer"
              onClick={() => {
                navigate("/issue-history");
              }}
            >
              <MoveLeft />
            </div>
            <div className="rounded-4 p-4" style={{ backgroundColor: "#F5F2FF" }}>
              <img src={issue} alt="issue" />
            </div>
            <div>
              <p className="m-0 fs-20 fw-600 mb-1">{issueDetails.name ?? ""}</p>
              <div className="d-flex align-items-center">
                <span className="me-2 fs-13 fw-600" style={{ color: "#8790A1" }}>
                  ID : {issueDetails.issue_id ?? ""}{" "}
                </span>
                <span className="me-2">•</span>
                <span className="border-0  py-1 px-4 rounded-pill fs-14 fw-400" style={{ backgroundColor: "#FFEFEF", color: "#172B4D" }}>
                  {issueDetails.type ?? ""}
                </span>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center gap-3">
            {issueDetails.issue_status !== "Closed" && (
              <Button
                onClick={() => {
                  setShowStatusUpdate(true);
                }}
                className="rounded-pill py-2 px-4"
              >
                Update status
              </Button>
            )}

            {checkPermission("Issue History", "edit_permission") && (
              <Button
                onClick={() => {
                  navigate("/issue-history", {
                    state: { id: location.state?.id },
                  });
                }}
                className="dark-purple-btn rounded-pill py-2 px-4"
              >
                Edit
              </Button>
            )}
          </div>
        </div>
        <div className="row w-100 m-0 pt-3">
          <div className="col-xl-7">
            <div className="bg-white h-100 p-3 rounded-4">
              <div className="p-3 rounded-4" style={{ backgroundColor: "#F8F8F8" }}>
                <div className="d-flex gap-3">
                  <div className="rounded-4" style={{ backgroundColor: "#E8E8E8" }}>
                    <img src={tata} alt="tata" />
                  </div>
                  <div>
                    <p className="m-0 fs-16 fw-semibold mb-1">{issueDetails.lic_no ?? ""}</p>
                    <div className="d-flex align-items-center">
                      <span className="me-2 fs-14 fw-400" style={{ color: "#A2A7AE" }}>
                        {issueDetails.vehicle_name ?? ""}
                      </span>
                      <span className="me-2">•</span>
                      {issueDetails.year_of_make && (
                        <span style={{ background: "#F0DBFF", color: "#A2A7AE" }} className="border-0 py-1 px-4 rounded-pill  fs-12">
                          {issueDetails.year_of_make ?? ""}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-4 mt-3 p-2 d-flex justify-content-center">
                  <span className="fs-13 fw-400" style={{ color: "#8790A1" }}>
                    Vehicle identification number (VIN) :{" "}
                  </span>
                  <span className="fs-14 fw-500">&nbsp;{issueDetails.vin ?? ""}</span>
                </div>
              </div>
              <p className="fs-16 fw-600 m-0 mt-3" style={{ color: "#212129" }}>
                Issue information
              </p>
              <div className="table-container rounded-4 overflow-hidden my-3">
                <table className="table table-borderless mb-0">
                  <tbody>
                    {details.map((item, index) => (
                      <tr key={index}>
                        <td className="fs-13 fw-500 w-25" style={{ color: "#49494B" }}>
                          {item.label}
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-xl-5">
            <div className="bg-white h-100 p-3 rounded-4">
              <p className="fs-16 fw-600" style={{ color: "#212129" }}>
                Attachments - {issueDetails?.images?.length}
              </p>
              {issueDetails?.images?.length > 0 && (
                <div
                  style={{
                    marginTop: "16px",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    gap: "16px",
                  }}
                >
                  {issueDetails?.images?.map((item, attachIndex) => (
                    <div
                      style={{
                        width: "312px",
                        height: "62px",
                        borderRadius: "12px",
                        padding: "12px 16px 12px 16px",
                        backgroundColor: "#F7F7F7",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img src={attachment} style={{ width: "37px", height: "36px" }} />
                      <div
                        style={{
                          width: "240px",
                          marginLeft: "8px",
                          marginTop: "4px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "500px",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                            marginBottom: "2px",
                          }}
                        >
                          {item.name}
                        </span>
                        <br />
                        <p
                          style={{
                            fontWeight: "400px",
                            fontSize: "12px",
                            lineHeight: "16.2px",
                            color: "#8790A1",
                          }}
                        >
                          {item.size}
                        </p>
                      </div>

                      {item.url && (
                        <div
                          onClick={() => {
                            downloadFile(item.url, item.url.split("/").pop());
                          }}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "100px",
                          }}
                        >
                          <img
                            src={download}
                            style={{
                              width: "12.8px",
                              height: "12px",
                              top: "10px",
                              left: "9.6px",
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="p-3">
          <div className="table-wrapper ">
            <table>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th
                        key={header.id}
                        className="px-3 py-2"
                        onClick={() => {
                          header.column.getToggleSortingHandler();
                        }}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {header.column.getIsSorted() === "asc" && " asc"}
                        {header.column.getIsSorted() === "desc" && " des"}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row, index) => (
                  <tr
                    key={row.id || "row-" + index}
                    onClick={() => {
                      if (row.original.id != null) {
                        navigate("/workorder/view", {
                          state: { id: row.original.id },
                        });
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id} className="px-3 py-2">
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
